import type { OppfolgingsplanFormUnderArbeid } from "@/schema/oppfolgingsplanForm/formValidationSchemas";

export const oppfolgingsplanFormDefaultValues: OppfolgingsplanFormUnderArbeid =
  {
    typiskArbeidshverdag: "",
    arbeidsoppgaverSomKanUtfores: "",
    arbeidsoppgaverSomIkkeKanUtfores: "",
    tidligereTilrettelegging: "",
    tilretteleggingFremover: "",
    annenTilrettelegging: "",
    hvordanFolgeOpp: "",
    evalueringsDato: null,
    evalueringPaaminnelse: null,
    harDenAnsatteMedvirket: null,
    denAnsatteHarIkkeMedvirketBegrunnelse: "",
  };
